import * as Api from 'mytours-read-api-typescript'

import { getConfiguration } from '../configuration/index'

let directApi: Api.MytoursApi | undefined
let cdnApi: Api.MytoursApi | undefined

export const fetchOverride = (url: string, options = {}): Promise<Response> => {
	const globalFetch = fetch(url, {
		...options,
		headers: {
			...((options as RequestInit).headers || {}),
			...getConfiguration().getApiHeaders(),
		},
	})
	return globalFetch
}

export function setApiConfig(projectId: string, apiKey: string) {
	// get api urls from platform functions
	const basePathDirect: string = getConfiguration().getDirectApiBaseUrl()
	const basePathCdn: string = getConfiguration().getCdnApiBaseUrl()

	directApi = new Api.MytoursApi(
		{ username: projectId, password: apiKey, basePath: basePathDirect },
		undefined,
		fetchOverride,
	)
	cdnApi = new Api.MytoursApi({ username: projectId, password: apiKey, basePath: basePathCdn }, undefined, fetchOverride)
}

// use direct api for fetching latest app.json
export function getDirectApi(): Api.MytoursApi {
	if (directApi === undefined) {
		// use default configuration
		const defaultConfig: Api.Configuration = getConfiguration().getDefaultApiConfiguration()
		const basePath: string = getConfiguration().getDirectApiBaseUrl()
		directApi = new Api.MytoursApi({ ...defaultConfig, basePath }, undefined, fetchOverride)
	}
	return directApi
}

// use CDN for all api calls, except for app.json
export function getApi(): Api.MytoursApi {
	if (cdnApi === undefined) {
		// use default configuration
		const defaultConfig: Api.Configuration = getConfiguration().getDefaultApiConfiguration()
		const basePath: string = getConfiguration().getCdnApiBaseUrl()
		cdnApi = new Api.MytoursApi({ ...defaultConfig, basePath }, undefined, fetchOverride)
	}
	return cdnApi
}
